// Timings for different application related threads in ms
import * as InactivityKey from "utils/interfaces/InactivityKey";

export const CUEPOINT_PREVIEW_HIDE_TIMEOUT = 3000;

export const INACTIVITY_TIMINGS = {
  [InactivityKey.CONTROLS]: 3,
  [InactivityKey.LOOPING_VIDEOS]: 60,
};

export const INACTIVITY_TOUCH_TIMINGS = {
  [InactivityKey.CONTROLS]: 3.5,
  [InactivityKey.LOOPING_VIDEOS]: 60,
};

export const SECOND_LEVEL_INACTIVITY_TIMINGS = {
  [InactivityKey.INTERVIEW_SIDEBAR]: 3.5,
  [InactivityKey.COMPACT_CONTROLS]: 10,
};
